export default (response) => response.fields;
